module.exports = __webpack_public_path__ + "img/language.76d42982.svg";